import React from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import PropTypes from 'prop-types'
import RainEffect from '../components/RainEffect'
import styles from './Error.module.scss'

const ErrorPage = ({ error }) => {
  const location = useLocation()
  const navigate = useNavigate()
  const errorFromState = location.state?.error
  const displayError = error || errorFromState

  const handleGoHome = () => {
    navigate('/')
  }

  return (
    <div className={styles['error-page']}>
      <RainEffect intensity={300} />
      <div className={styles['error-content']}>
        <div className={styles['error-box']}>
          <FontAwesomeIcon icon='exclamation-circle' size='3x' className={styles['text-danger']} />
          <h1 className={styles['error-title']}>Oops!</h1>
          <h2 className={styles['error-subtitle']}>Something went wrong</h2>
          <p className={styles['error-message']}>
            {displayError?.message || 'An unexpected error occurred. Please try again later.'}
          </p>
          {displayError?.details && (
            <details className={styles['error-details']}>
              <summary className={styles['error-details-summary']}>Technical Details</summary>
              <pre className={styles['error-details-content']}>
                {JSON.stringify(displayError.details, null, 2)}
              </pre>
            </details>
          )}
          <button
            className={styles['home-button']}
            onClick={handleGoHome}
          >
            <FontAwesomeIcon icon='home' className={styles['button-icon']} />
            Go to Home
          </button>
        </div>
      </div>
    </div>
  )
}

ErrorPage.propTypes = {
  error: PropTypes.shape({
    message: PropTypes.string,
    details: PropTypes.any
  })
}

export default ErrorPage
